import { render, staticRenderFns } from "./StoryManage.vue?vue&type=template&id=ea5baa94&scoped=true"
import script from "./StoryManage.vue?vue&type=script&lang=js"
export * from "./StoryManage.vue?vue&type=script&lang=js"
import style0 from "./StoryManage.vue?vue&type=style&index=0&id=ea5baa94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5baa94",
  null
  
)

export default component.exports